import React, { useState, useEffect, useRef, useCallback } from "react";
import "./calibrationReportView.css";
import { PiDotsThreeOutlineVerticalFill } from "react-icons/pi";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import { IoSearchOutline } from "react-icons/io5";
import { TbRefresh } from "react-icons/tb";
import Tooltip from "@mui/material/Tooltip";
import API_URL from "../Config";
import { IoMdArrowBack } from "react-icons/io";
import Pagination from "../Component/Pagination";
import CylinderPopup from "../RunningAccountsProject/Popup/CylinderPopup";

// Debounce utility function
const debounce = (func, delay) => {
  let timeoutId;
  return (...args) => {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => func.apply(null, args), delay);
  };
};

function CalibrationReportView({ isSidebarExpanded }) {
  const { detector_id, status, filter_option, startDate, endDate } =
    useParams();
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isSortPopup, setIsSortPopup] = useState(false);
  const [isAscending, setIsAscending] = useState(true);
  const [searchInput, setSearchInput] = useState("");
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(50);
  const [totalItems, setTotalItems] = useState(0);
 const [isCylinderPopupOpen, setIsCylinderPopupOpen] = useState(false);
  const [selectedDetectorId, setSelectedDetectorId] = useState(null);
  const [selectedScheduleId, setSelectedScheduleId] = useState(null);

  const formatDate = (date) => {
    const options = { year: "numeric", month: "2-digit", day: "2-digit" };
    return new Date(date)
      .toLocaleDateString("en-CA", options)
      .replace(/-/g, "/");
  };

  const fetchData = async (currentPage, itemsPerPage, searchQuery = "") => {
    try {
      setLoading(true);
      const authKey = localStorage.getItem("authKey");

      const params = {
        detector_id,
        filter_option: filter_option,
        status,
        page: currentPage,
        per_page: itemsPerPage,
      };

      // ✅ Only send start_date and end_date if filter_option is "custom_date"
      if (filter_option === "custom_date" && startDate && endDate) {
        params.start_date = startDate;
        params.end_date = endDate;
      }

      // ✅ Add search query if provided
      if (searchQuery && searchQuery.trim() !== "") {
        params.query = searchQuery.trim();
      }

      const response = await axios.get(
        `${API_URL}/api/reports/gas_detector/calibration_details`,
        {
          headers: {
            Authorization: authKey,
          },
          params,
        }
      );

      console.log("response.data.records", response?.data?.records);
      setReports(response?.data?.records);
      setTotalItems(response?.data?.total);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching schedule report:", error.message);
      setLoading(false);
    }
  };

  // const fetchData = async (currentPage, itemsPerPage, searchQuery = "") => {
  //   try {
  //     setLoading(true);
  //     const authKey = localStorage.getItem("authKey");

  //     const params = {
  //       detector_id,
  //       filter_option: filter_option,
  //       status,
  //       start_date: startDate,
  //       end_date: endDate,
  //       page: currentPage,
  //       per_page: itemsPerPage,
  //     };

  //     // Add search query if provided
  //     if (searchQuery && searchQuery.trim() !== "") {
  //       params.query = searchQuery.trim();
  //     }

  //     const response = await axios.get(
  //       `${API_URL}/api/reports/gas_detector/calibration_details`,
  //       {
  //         headers: {
  //           Authorization: authKey,
  //         },
  //         params,
  //       }
  //     );
  //     console.log("response.data.records", response?.data?.records);
  //     setReports(response?.data?.records);
  //     setTotalItems(response?.data?.total);
  //     setLoading(false);
  //   } catch (error) {
  //     console.error("Error fetching schedule report:", error.message);
  //     setLoading(false);
  //   }
  // };

  // Debounced search function
  const debouncedSearch = useCallback(
    debounce((searchQuery) => {
      // Reset to page 1 when searching
      setPage(1);
      fetchData(1, itemsPerPage, searchQuery);
    }, 300), // 300ms delay
    [itemsPerPage, detector_id, filter_option, status, startDate, endDate]
  );

  useEffect(() => {
    console.log("filter_option:", JSON.stringify(filter_option, null, 2));
    fetchData(page, itemsPerPage, searchInput);
  }, [
    detector_id,
    filter_option,
    status,
    page,
    itemsPerPage,
    startDate,
    endDate,
  ]);

  const handlePaginationChange = (currentPage, newItemsPerPage) => {
    setPage(currentPage);
    setItemsPerPage(newItemsPerPage);

    // Only store values in localStorage if we're not currently searching
    if (!searchInput || searchInput.trim() === "") {
      localStorage.setItem("currentPage", currentPage);
      localStorage.setItem("itemsPerPage", newItemsPerPage);
    }
  };

  const containerRef = useRef(null);

  const handleSearchInputChange = (event) => {
    const value = event.target.value;
    setSearchInput(value);

    if (value.trim() === "") {
      // If search is cleared, fetch data immediately without debounce
      setPage(1);
      fetchData(1, itemsPerPage, "");
    } else {
      // Use debounced search for non-empty queries
      debouncedSearch(value);
    }
  };

  const handleSortpopup = () => {
    setIsSortPopup(!isSortPopup);
  };

  const closePopups = () => {
    setIsSortPopup(false);
  };

  const handleRefresh = () => {
    setSearchInput("");
    setPage(1);
    fetchData(1, itemsPerPage, "");
  };

  const handleBackScheduler = () => {
    navigate("/gas-detector-calibration-report");
  };

  const getStatusColor = (status) => {
    switch (status.toLowerCase()) {
      case "active":
        return "rgb(41, 128, 185)";
      case "cancelled":
        return "red";
      case "overdue":
        return "#C0612B";
      case "pending":
        return "#d4ac0d";
      case "completed":
        return "#2e8b57";
      case "failed":
        return "#df7f26";
      default:
        return "black";
    }
  };

  const handleViewClick = async (scheduler_id) => {
    navigate(`/scheduler-view/${scheduler_id}`);
  };

  const formatDates = (dateString) => {
    if (!dateString || typeof dateString !== "string") {
      return "";
    }
    const date = new Date(dateString);
    if (isNaN(date.getTime())) {
      return "";
    }

    const formatter = new Intl.DateTimeFormat("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "2-digit",
    });
    return formatter.format(date);
  };

  console.log("filter", filter_option, startDate, endDate);
  // const displayText = filterOptionMap[filter_option] || filter_option;

  const openCylinderPopup = (detectorId, scheduleId) => {
    setSelectedDetectorId(detectorId);
    setSelectedScheduleId(scheduleId);
    setIsCylinderPopupOpen(true);
  };

  const handlecalibrationLogs = (id) => {
    navigate(`/calibration-logs/${id}`);
  };

  const closePopup = () => {
    setIsCylinderPopupOpen(false);
  };

  const handleStatusChange = () => {
    fetchData(
      page,
      itemsPerPage,
      // selectedFilter,
      // selectedStartDate,
      // selectedEndDate
    );
  };

  const closeCylinderPopup = () => {
    setIsCylinderPopupOpen(false); // Hide the popup
    setSelectedDetectorId(null); // Reset the ID
  };

  return (
    <>
      <div
        className={`data-list-content-container page-content ${
          isSidebarExpanded ? "expanded" : "collapsed"
        }`}
      >
        <div className="data-list-content" ref={containerRef}>
          <div className="data-list-header">
            <div className="data-list-header-content">
              <div className="data-list-heading-content-left-side">
                <Tooltip title="Back" arrow>
                  <IoMdArrowBack
                    className="back-company"
                    onClick={handleBackScheduler}
                  />
                </Tooltip>
                {reports?.length > 0 && (
                  <>
                    <span className="report-name">Calibration Report View</span>
                    <span
                      className="status-show"
                      style={{
                        color: getStatusColor(reports[0].status),
                        fontWeight: "500",
                      }}
                    >
                      {reports[0].status
                        ? reports[0].status.charAt(0).toUpperCase() +
                          reports[0].status.slice(1).toLowerCase()
                        : "0"}
                    </span>
                    {filter_option === "all" ? (
                       <span>
                    <span style={{ color: "#007bff" }}> (Date: All dates)</span>
                  </span>
                    ) : (
                      <span
                        className="option-show"
                        style={{
                          color: "#007bff",
                          marginLeft: "15px",
                          fontWeight: "500",
                        }}
                      >
                        {formatDates(startDate)}
                        {startDate && endDate && ` - ${formatDates(endDate)}`}
                      </span>
                    )}
                    {/* <span
                      className="option-show"
                      style={{
                        color: "#ce9139ed",
                        marginLeft: "15px",
                        fontWeight: "500",
                      }}
                    >
                      {formatDates(startDate)} - {formatDates(endDate)}
                    </span> */}
                  </>
                )}
              </div>

              <div className="data-list-heading-content-right-side">
                <div className="search-bar-container">
                  <input
                    type="text"
                    placeholder="Search ..."
                    value={searchInput}
                    onChange={handleSearchInputChange}
                    className="search-bar"
                  />
                  <IoSearchOutline className="search-bar-icon" />
                </div>

                <Tooltip title="Refresh List" arrow>
                  <button className="refresh-button" onClick={handleRefresh}>
                    <TbRefresh className="refresh-icon" />
                  </button>
                </Tooltip>
                <button className="sort-button" onClick={handleSortpopup}>
                  <PiDotsThreeOutlineVerticalFill className="sort-icon" />
                </button>
                {isSortPopup && (
                  <div className="sort-popup-container">
                    <div className="sort-popup-content">
                      <div className="sort-by">
                        SORT BY {isAscending ? "(Ascending)" : "(Descending)"}
                      </div>
                      <div className="sort-by-button"></div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="data-list-body" onClick={closePopups}>
            <div className="data-list-scroll-body">
              <div className="data-list-table">
                {loading ? (
                  <div className="loader-container">
                    <div className="loader"></div>
                    <div>Loading...</div>
                  </div>
                ) : reports?.length > 0 ? (
                  <table className="table multilevel-data">
                    <thead>
                      <tr>
                        <th >SR. NO.</th>
                        <th>TAG NO</th>
                        <th >STATUS</th>
                        <th>CALIBRATION DUE DATE</th>
                        <th>LAST CALIBRATION DATE</th>
                        <th>ACTION</th>
                      </tr>
                    </thead>
                    <tbody className="data-list-scroll-bodys">
                      {reports.map((report, index) => (
                        <tr key={index} className="hoverable-row">
                          <td >{report.sr_no}</td>
                          <td>{report?.tag_no || "NA"}</td>
                          <td className="status-schedules" style={{justifyContent:'start'}}>
                            <div
                              style={{
                                backgroundColor:
                                  report.status === "cancelled"
                                    ? "red"
                                    : report.status === "failed"
                                    ? "#df7f26"
                                    : report.status === "Overdue"
                                    ? "#C0612B"
                                    : report.status === "Active"
                                    ? "rgb(41, 128, 185)"
                                    : report.status === "Pending"
                                    ? "#d4ac0d"
                                    : report.status === "completed"
                                    ? "#2e8b57"
                                    : "black",
                                width: "6vw",
                              }}
                            >
                              {report?.status
                                ? report?.status.charAt(0).toUpperCase() +
                                  report?.status.slice(1).toLowerCase()
                                : "NA"}
                            </div>
                          </td>
                          <td>
                            {formatDate(report?.calibration_due_date || "NA")}
                          </td>
                          <td>
                            {formatDate(report?.last_calibration_date || "NA")}
                          </td>

                           <td>
                            <div className="buttons">
                              <button
                                className="button-bgsss"
                                onClick={() =>
                                  openCylinderPopup(
                                    detector_id, report?.id
                                  )
                                }
                              >
                                Change Status
                              </button>
                              <button
                                className="button-bgsss"
                                onClick={() =>
                                  handlecalibrationLogs(detector_id)
                                }
                              >
                                Calibration Logs
                              </button>
                            </div>
                          </td>

                          {/* <td className="center-alignment">
                            <button
                              onClick={() => handleViewClick(report?.id)}
                              className="button-bg"
                            >
                              View
                            </button>
                          </td> */}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                ) : (
                  <div className="no-users-container">
                    <div className="no-users-message">
                      No Calibration Report Found
                    </div>
                  </div>
                )}
              </div>

              {isCylinderPopupOpen && (
                <CylinderPopup
                  closePopup={closePopup}
                  handleNewDepartment={handleStatusChange} // 👈 passed here
                  detectorId={selectedDetectorId}
                  scheduleId={selectedScheduleId}
                />
              )}
              
              <Pagination
                showPerPage={itemsPerPage}
                total={totalItems}
                onPaginationChange={handlePaginationChange}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default CalibrationReportView;
